// Unpublished Work © 2022-2024 Deere & Company.

import PropTypes from 'Utils/prop-type-utils';
import serviceStatusConstants from 'Ui/constants/service-status-constants';

function ServiceStatus(props) {
    const {
        status,
        translations
    } = props;

    const statusConstant = serviceStatusConstants[status];
    const statusText = translations[statusConstant.title] || statusConstant.title;

    return statusText;
}

ServiceStatus.propTypes = {
    status: PropTypes.string,
    translations: PropTypes.translations
};

export default ServiceStatus;
